export default "__VITE_ASSET__CXu2Z7ST__"